module.exports = __webpack_public_path__ + "static/u-s-bankruptcy-filings-5-1fdd40deac329daab33fc43b6842d049.png";